/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { CompletedEvaluation } from './completedEvaluation';

export type GenericApiResponseListCompletedEvaluationData = CompletedEvaluation[] | null;
